

import axios from 'axios';
import getHeaders from '../../constants/headers';
import { STORE_BASE_URL } from '../BaseURL';

export const getCartPackage = (storeCustomerId, storeId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/store/' +
      storeId +
      '/store-customer/' +
      storeCustomerId +
      '/cart-package', // for android use
    headers: getHeaders(),
  });
};

export const putCartPackage = (storeCustomerId, storeId, data) => {
  return axios({
    method: 'put',
    url:
      STORE_BASE_URL +
      '/store/api/secure/store/' +
      storeId +
      '/store-customer/' +
      storeCustomerId +
      '/cart-package', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const PackageCountUpdate = (
  storeCustomerId,
  storeId,
  orderId,
  orderPackageId,
  data,
) => {
  return axios({
    method: 'put',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      storeCustomerId +
      '/order/' +
      orderId +
      '/order-package/' +
      orderPackageId, // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

//store/api/secure/v1/store/{storeId}/store-customer/{storeCustomerId}/order/{orderId}/order-package/{orderPackageId}
